import Presentation from "./presentation";
import useFetchList from "./useFetchList";

const CategoryPage = ( { data } ) => {

	const { __data, fetchMore, isEmpty, isLoadingMore } = useFetchList ( { data } );

	return (
		<Presentation
			data       = { data }
			fetchMore  = { fetchMore }
			isDepleted = { isEmpty }
			isLoading  = { isLoadingMore }
			list2      = { __data }
		/>
	);
};

export default CategoryPage;

